<router-outlet></router-outlet>

<!-- type="line-spin-clockwise-fade" -->
<ngx-spinner
    fullScreen="false"
    bdColor="rgba(0,0,0,0.4)"
    size="large"
    color="#fff"
    type="ball-clip-rotate">
</ngx-spinner>